// CustomersPage - Wrapper component for customers list view
// Created as part of ENG2-1701: Update Routing and Page Integration

import React from 'react'
import { Box, Tooltip } from '@mui/material'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useIntl } from 'react-intl'
import { Topbar } from 'layouts'
import { ActionDialog, Button, Stack } from 'components'
import CustomersTable from './customers-table'
import CreateCustomerDialog from 'components/dialogs/create-customer-dialog'
import NewUserSetting from 'components/new-user-setting'
import { useRisikaUsers } from 'services/queries/use-risika-users'
import { useUserAuth } from 'contexts/google-auth'
import { userAllowedToAddNewSettings } from 'utils/constants'
import intl from 'localization/components'

const CustomersPage: React.FC = () => {
  const { formatMessage } = useIntl()
  const { data: risikaUsers } = useRisikaUsers()
  const { user } = useUserAuth()
  const userEmail = user?.email
  const canIAddNewSettings = userAllowedToAddNewSettings.includes(userEmail || '')

  return (
    <>
      <Topbar
        title="Customers"
        actions={
          <Stack spacing={1}>
            <ActionDialog
              title={formatMessage({
                id: intl.customerManagement('new-customer-title'),
              })}
              removeActions
              content={(close: () => void) => (
                <CreateCustomerDialog risikaUsers={risikaUsers?.data} closeFn={close} />
              )}
              maxWidth="sm"
              fullWidth={true}
              agreeText={formatMessage({ id: intl.generic('create') })}
              render={(open: () => void) => (
                <Button onClick={open} icon={<FontAwesomeIcon icon={faPlus} />}>
                  New Company
                </Button>
              )}
            />
            <ActionDialog
              title="User Settings"
              removeActions
              content={() => <NewUserSetting />}
              maxWidth="sm"
              fullWidth={true}
              agreeText={formatMessage({ id: intl.generic('create') })}
              render={(open: () => void) =>
                canIAddNewSettings ? (
                  <Button onClick={open} icon={<FontAwesomeIcon icon={faPlus} />}>
                    User Settings
                  </Button>
                ) : (
                  <Tooltip title="Oops you can't add new settings. If you think this is a mistake, get in contact with the frontend team.">
                    <Box>
                      <Button
                        disabled={true}
                        onClick={open}
                        icon={<FontAwesomeIcon icon={faPlus} />}
                      >
                        User Settings
                      </Button>
                    </Box>
                  </Tooltip>
                )
              }
            />
          </Stack>
        }
      />
      <Box sx={{ p: 3 }}>
        <CustomersTable />
      </Box>
    </>
  )
}

export { CustomersPage }
export default CustomersPage
